import { useState } from "react";

function useProvideAuth() {
  const [user, setUser] = useState(localStorage.getItem("token"));
  const [userName, setUserName] = useState(localStorage.getItem("name"));
  const [picture, setPicture] = useState(localStorage.getItem("picture"));
  const [phone, setPhone] = useState(localStorage.getItem("phone"));
  const [mail, setMail] = useState(localStorage.getItem("mail"));
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem("isAdmin"));

  // *User
  const userLogin = (data) => {
    console.log("🚀 ~ userLogin ~ data:", data)
    localStorage.setItem("token", data.token);
    localStorage.setItem("name", data.name);
    localStorage.setItem("picture", data.image);
    localStorage.setItem("phone", data.phone_Number);
    localStorage.setItem("mail", data.email);
    localStorage.setItem("role", data.roles);
    localStorage.setItem("isAdmin", data._id);
    setUser(data.token);
    setUserName(data.name);
    setPicture(data.image);
    setPhone(data.phone_Number);
    setMail(data.mail);
    setRole(data.roles);
    setIsAdmin(data._id);
  };

  const userLogout = async () => {
    setUser(null);
    localStorage.clear();
  };

  // *Verify Token
  const verifyToken = () => {
    const token = localStorage.getItem("token");
    const name = localStorage.getItem("name");
    setUser(token);
    setUserName(name);
  };

  return {
    user,
    userName,
    picture,
    phone,
    mail,
    role,
    isAdmin,
    userLogin,
    userLogout,
    verifyToken,
  };
}

export default useProvideAuth;
